<template>
  <div id="ap-mssage-box" v-if="show">
    <div class="ap-mssage-box-tit">
      <h1>提示</h1>
    </div>
    <p>该文件超过30M，暂不支持在线查看，请下载后查看</p>
    <div class="ap-mssage-box-cuoz">
      <span @click="cancel">取消</span>
      <!-- <a :href="url" :download="name" @click="cancel">立即下载</a> -->
      <!-- <span @click="down">立即下载</span> -->
      <a :href="url" target="_blank"><b @click="cancel2">立即下载</b></a>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        show: false,
        url: '',
        name: '',
        instance: null
      }
    },
    methods: {
      init(url, name) {
        this.show = true
        this.url = url
        this.name = name
      },
      cancel() {
        this.show = false
      },
      cancel2() {
        this.show = false
      },
      down() {
        this.show = false
        this.instance  = this.$notify({
          title: '提示',
          message: '正在下载中, 请耐心等待...',
          duration: 0
        });
        // if (fileType == 'doc') {
        //   cType = 'application/msword'
        // }
        // if (fileType == 'img') {
        //   if (suffix == 'png') {
        //     cType = 'application/x-png'
        //   }
        //   if (suffix == 'jepg' || suffix == 'jpg') {
        //     cType = 'application/x-jpg'
        //   }
        //   if (suffix == 'gif') {
        //     cType = 'image/gif'
        //   }
        //   if (suffix == 'svg') {
        //     cType = 'text/xml'
        //   }
        // }
        // if (fileType == 'xls') {
        //   cType = 'application/x-xls'
        // }
        var formData = new FormData();
        formData.append('url', this.url);
        formData.append('fileName', this.name);
        let aa = this.name.split('.')
        let bb = this.url.split('.')

        let cType='';//确认上传文件应传content-type
        let fileType=this.$utils.regExpFileIco(aa[1]);//判断文件类型
        let fileType2=this.$utils.regExpFileIco(bb[bb.length - 1]);//判断文件类型
        if(fileType=='doc' || fileType=='docx'){
          cType='application/msword'
        }
        if(fileType=='img'){
          let suffix=aa[1].toLocaleLowerCase()
          if(suffix=='png'){
            cType='application/x-png'
          }
          if(suffix=='jepg'||suffix=='jpg'){
            cType='application/x-jpg'
          }
          if(suffix=='gif'){
            cType='image/gif'
          }
          if(suffix=='svg'){
            cType='text/xml'
          }
        }
        if(fileType=='xls'){
          cType='application/x-xls'
        }
        if(fileType=='pdf'){
          cType='application/pdf'
        }
        if(fileType2 == 'pdf'){
          cType='application/pdf'
          let cc = this.name.split('.')
          // dd = ''
          // for(let k=0;k<cc.length-1;k++) {
          //   dd = cc[k].join('.')
          // }
          this.name = cc[0]+'.pdf'
        }
         
        let that = this;
        this.axios({
            method: "POST",
            url: '/project/todownload',
            responseType: 'arraybuffer',
            data: formData,
            // headers: {
            //   'Content-Type': cType + ';charset=UTF-8'
            // }
          })
          .then(function (response) {
            
            //创建blob对象
            let blob = new Blob([response.data], {type: cType});
            
            // 创建隐藏的可下载链接
            var eleLink = document.createElement('a');
            eleLink.download = that.name;
            eleLink.style.display = 'none';
            // 字符内容转变成blob地址
            eleLink.href = URL.createObjectURL(blob);
            // 触发点击
            document.body.appendChild(eleLink);
            eleLink.click();
            // 然后移除
            document.body.removeChild(eleLink);

            that.instance.close()
          })
      }
    }
  }

</script>

<style lang="scss">
  #ap-mssage-box {
    width: 500px;
    box-sizing: border-box;
    border: 1px solid #E4E7ED;
    border-radius: 4px;
    background-color: #FFF;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 15px 10px;
    display: block;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    margin: 0;
    z-index: 999999999;

    .ap-mssage-box-tit {
      h1 {
        font-size: 18px
      }
    }

    p {
      font-size: 14px;
      margin: 15px 0;
      color: #333
    }

    .ap-mssage-box-cuoz {
      display: flex;
      justify-content: flex-end;
      width: auto;

      a,
      span {
        text-decoration: none;
        display: inline-block;
        width: 70px;
        height: 36px;
        line-height: 36px;
        border-radius: 4px;
        text-align: center;
        border: 1px solid #E4E7ED;
        color: #409EFF;
        margin-left: 20px;
        font-size: 14px;
        cursor: pointer
      }
      a {
        b {
          font-weight: normal
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/paging/pcClient/popupModule/structFile/downFile/down.vue